﻿import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Container } from "@mui/material";
import { MenuItemEnum } from "@/utils/utils";
import MainNavigation from "@/components/MainNavigation/MainNavigation";
import { ShepTab, ShepTabs } from "@/components/GenericComponents/ShepComponents";
import dayjs from "dayjs";
import _ from "lodash";
import CatalogGrid from "./CatalogGrid";
import CrossReferenceGrid from "./CrossReferenceGrid";
import {
  selectDateFilter,
  selectCatalogSummaryFilterTypes,
  selectCatalogSummaryRecordsLoaded,
  selectCatalogSummaryRecords,
  selectCrossReferenceSummaryFilterTypes,
  selectCrossReferenceSummaryRecordsLoaded,
  selectCrossReferenceSummaryRecords,
} from "@/features/maintenance/maintenanceSlice";
import { WorkflowLookupsProvider } from "./WorkflowLookups/WorkflowLookupsContext";
import FileImportPopup from "../FileImport/FileImportPopup";
import WorkflowLookupsTab from "./WorkflowLookups/WorkflowLookupsTab";
import ConnectionCustomFieldHome from "./ConnectionCustomField/ConnectionCustomFieldHome";

const Maintenance = () => {
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = useState(0);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);

    // heap.io
    switch (newValue) {
      case 0:
        window.heap.track("Maintenance - Select Cross References Tab");
        break;
      case 1:
        window.heap.track("Maintenance - Select Catalog Data Tab");
        break;
    }
  };

  return (
    <Container sx={{ backgroundColor: "var(--disabled)", maxWidth: "100%" }}>
      <FileImportPopup />
      <Container
        sx={{
          position: "sticky",
          top: "0",
          zIndex: "10",
          maxWidth: "100%",
        }}
      >
        <MainNavigation selected={MenuItemEnum.Maintenance} />
      </Container>
      <Container className="content-container" sx={{ maxWidth: "100%" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            borderBottom: "1.5px solid var(--primary-main)",
            marginBottom: "30px",
          }}
        >
          <ShepTabs
            sx={{
              margin: "1px 30px 0px 0",
            }}
            variant="primary"
            value={tabValue}
            onChange={handleTabChange}
          >
            <ShepTab
              variant="primary"
              key="1"
              label={"Cross References"}
              id="tab-0"
              aria-controls="tabpanel-0"
              sx={{ width: "310px" }}
            />
            <ShepTab
              variant="primary"
              key="2"
              id="tab-1"
              aria-controls="tabpanel-1"
              label={"Catalog Data"}
              iconPosition="start"
            />
            <ShepTab
              variant="primary"
              key="3"
              id="tab-1"
              aria-controls="tabpanel-1"
              label={"Workflow Lookups"}
              iconPosition="start"
            />
            <ShepTab
              variant="primary"
              key="3"
              id="tab-1"
              aria-controls="tabpanel-1"
              label={"Connection Fields"}
              iconPosition="start"
            />
          </ShepTabs>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              flex: 1,
              marginTop: "auto",
              marginBottom: "5px",
            }}
          ></div>
        </div>
        <Box
          className="content-box"
          sx={{ display: "flex", flexDirection: "row", width: "100%" }}
        >
          {tabValue === 0 && <CrossReferenceGrid />}
          {tabValue === 1 && <CatalogGrid />}
          {tabValue === 2 && (
            <WorkflowLookupsProvider>
              <WorkflowLookupsTab />
            </WorkflowLookupsProvider>
          )}
          {tabValue === 3 && <ConnectionCustomFieldHome />}
        </Box>
      </Container>
    </Container>
  );
};

export default Maintenance;
